import './App.css';
import styled, { ThemeProvider } from "styled-components";
import theme from './utils/Themes';
import { MotionConfig } from 'framer-motion';

import Navbar from './components/Navbar';
import Hero from './components/HeroSection';
import About from './components/About';
import Experience from "./components/Experience";
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from "./components/Footer";
import AskWidget from './components/AskWidget';

const Body = styled.div`
  background-color: ${({ theme }) => theme.biome.about.bg};
  color: ${({ theme }) => theme.biome.about.ink};
  width: 100%;
  overflow-x: clip;
  position: relative;
`;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <MotionConfig reducedMotion="user">
        <Navbar />
        <Body>
          <Hero />
          <About />
          <Experience />
          <Projects />
          <Contact />
          <Footer />
        </Body>
        <AskWidget />
      </MotionConfig>
    </ThemeProvider>
  );
}

export default App;
